import React, { useState } from 'react';

const SearchBox = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = () => {
    alert(`Searching for: ${searchTerm}`);
  };

  return (
    <section className="container my-5"><br/><br/>
      <h3 className="text-center mb-5 section-title">Find Services</h3>
      <div className="row g-3 align-items-end">
        <div className="col-lg-6">
          <input 
            className="form-control search-input form-large fs-5 py-3" 
            placeholder="Enter pickup location, destination or keyword"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="col-lg-3">
          <select className="form-select form-large fs-5 py-3">
            <option>All Categories</option>
            <option>Courier</option>
            <option>Cargo</option>
            <option>Combine Shipping</option>
          </select>
        </div>
        <div className="col-lg-3">
          <button className="btn btn-primary w-100 fs-5 py-3 book-main-btns" onClick={handleSearch}>
            <i className="fas fa-search me-2"></i> Search
          </button>
        </div>
      </div>
    </section>
  );
};

export default SearchBox;
